export { MapComponent } from './MapComponent.js';